import Header from "../Components/Header/Header";
import Home from "../Components/BannerMain/BannerMain";
import AboutBB from "../Components/AboutBB/AboutBB";
import ValuesAndZens from "../Components/ValuesAndZen/ValuesAndZen";
import BlackSection from "../Components/BlackSection/BlackSection";
import Identified from "../Components/Identified/Identified";
import Footer from "../Components/Footer/Footer";
import logo from './../Images/BREACH_BUSTER_HACKING_CLUB__1_-removebg-preview.webp'
import { AboutBgColorHome, AboutbgColorHeader, aboutTitle, linkHeader,navLinksAbout,navLinksHome,subTitleAbout,textColorAbout } from "./Config";
import BannerMain from "../Components/BannerMain/BannerMain";

const About = () => {
    return (
        <>
            <Header logo={logo} 
            bgColor={AboutbgColorHeader}
                linkContact={linkHeader} 
                textColor={textColorAbout}
                logoSize="w-15 h-20 p-2"
                navLinks={navLinksAbout}/>
            <BannerMain bgColor={AboutBgColorHome}
                title={aboutTitle}
                subTitle={subTitleAbout}
            />
            <AboutBB />
            <ValuesAndZens />
            <BlackSection />
            {/* <Actions /> */}
            <Identified />
            <Footer />
        </>
    )
}

export default About;